import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const getFundsReportList = async ({ selectedFiduciary }) => {
  const url = `/fiduciaries/${selectedFiduciary.id}/investment-reports`;
  return request.get(url);
};
